import { forwardRef, useMemo } from 'react'

import { MetalTierBadge, Tooltip } from 'slab'

export type MetalTier = 'bronze' | 'expanded_bronze' | 'silver' | 'gold' | 'platinum' | 'catastrophic'

interface OnboardingMetalTierBadgeProps {
  bordered?: boolean;
  tier: MetalTier
}

const BRONZE_INFO =
  "Lowest monthly price, but you'll pay more when you get care — best if you rarely go to the doctor"
const EXPANDED_BRONZE_INFO =
  'Still low monthly price like Bronze, but may cover a few things — like some doctor visits — before you hit your deductible'
const SILVER_INFO =
  'A balance of monthly price and coverage — often a good fit if you expect moderate care'
const GOLD_INFO =
  'Higher monthly price, but lower costs when you get care — better if you have regular medical needs'
const PLATINUM_INFO =
  "Highest monthly cost, but you'll pay very little when you use care — great for frequent or ongoing care"

export const OnboardingMetalTierBadge = forwardRef<
  HTMLSpanElement,
  OnboardingMetalTierBadgeProps
>(({ bordered = false, tier }, forwardedRef) => {
  const { tooltipContent } = useMemo(() => {
    let tooltipContent: string
    switch (tier) {
      case 'bronze':
        tooltipContent = BRONZE_INFO
        break
      case 'expanded_bronze':
        tooltipContent = EXPANDED_BRONZE_INFO
        break
      case 'silver':
        tooltipContent = SILVER_INFO
        break
      case 'gold':
        tooltipContent = GOLD_INFO
        break
      case 'platinum':
        tooltipContent = PLATINUM_INFO
        break
      case 'catastrophic':
        tooltipContent = ''
        break
      default:
        tooltipContent = ''
    }

    return { tooltipContent }
  }, [tier])

  return (
    <Tooltip content={tooltipContent}>
      <MetalTierBadge tier={tier} bordered={bordered} ref={forwardedRef} />
    </Tooltip>
  )
})
